import { networks } from 'bitcoinjs-lib';

export const convertNetworkIdForPsbt = (networkId: string) => {
  if (networkId === '1') {
    return networks.bitcoin;
  }

  // use networks.testnet for both testnet and signet
  if (networkId === '2' || networkId === '3') {
    return networks.testnet;
  }

  return undefined;
};
